export const languages = [
  { code: "en-GB", name: "English (UK)", nativeName: "English", flag: "🇬🇧", rtl: false },
  { code: "en-US", name: "English (US)", nativeName: "English", flag: "🇺🇸", rtl: false },
  { code: "en-AU", name: "English (Australia)", nativeName: "English", flag: "🇦🇺", rtl: false },
  { code: "en-CA", name: "English (Canada)", nativeName: "English", flag: "🇨🇦", rtl: false },
  { code: "en-IN", name: "English (India)", nativeName: "English", flag: "🇮🇳", rtl: false },
  { code: "en-SG", name: "English (Singapore)", nativeName: "English", flag: "🇸🇬", rtl: false },
  { code: "en-ZA", name: "English (South Africa)", nativeName: "English", flag: "🇿🇦", rtl: false },
  { code: "af", name: "Afrikaans", nativeName: "Afrikaans", flag: "🇿🇦", rtl: false },
  { code: "am", name: "Amharic", nativeName: "አማርኛ", flag: "🇪🇹", rtl: false },
  { code: "ar", name: "Arabic", nativeName: "العربية", flag: "🇸🇦", rtl: true },
  { code: "az-AZ", name: "Azerbaijani", nativeName: "Azərbaycan", flag: "🇦🇿", rtl: false },
  { code: "be", name: "Belarusian", nativeName: "Беларуская", flag: "🇧🇾", rtl: false },
  { code: "bg", name: "Bulgarian", nativeName: "Български", flag: "🇧🇬", rtl: false },
  { code: "bn-BD", name: "Bengali", nativeName: "বাংলা", flag: "🇧🇩", rtl: false },
  { code: "ca", name: "Catalan", nativeName: "Català", flag: "🇪🇸", rtl: false },
  { code: "cs-CZ", name: "Czech", nativeName: "Čeština", flag: "🇨🇿", rtl: false },
  { code: "da-DK", name: "Danish", nativeName: "Dansk", flag: "🇩🇰", rtl: false },
  { code: "de-DE", name: "German", nativeName: "Deutsch", flag: "🇩🇪", rtl: false },
  { code: "el-GR", name: "Greek", nativeName: "Ελληνικά", flag: "🇬🇷", rtl: false },
  { code: "es-ES", name: "Spanish (Spain)", nativeName: "Español", flag: "🇪🇸", rtl: false },
  {
    code: "es-419",
    name: "Spanish (Latin America)",
    nativeName: "Español",
    flag: "🌎",
    rtl: false,
  },
  { code: "es-US", name: "Spanish (US)", nativeName: "Español", flag: "🇺🇸", rtl: false },
  { code: "et", name: "Estonian", nativeName: "Eesti", flag: "🇪🇪", rtl: false },
  { code: "eu-ES", name: "Basque", nativeName: "Euskara", flag: "🇪🇸", rtl: false },
  { code: "fa", name: "Persian", nativeName: "فارسی", flag: "🇮🇷", rtl: true },
  { code: "fa-AE", name: "Persian (UAE)", nativeName: "فارسی", flag: "🇦🇪", rtl: true },
  { code: "fa-AF", name: "Persian (Afghanistan)", nativeName: "فارسی", flag: "🇦🇫", rtl: true },
  { code: "fa-IR", name: "Persian (Iran)", nativeName: "فارسی", flag: "🇮🇷", rtl: true },
  { code: "fi-FI", name: "Finnish", nativeName: "Suomi", flag: "🇫🇮", rtl: false },
  { code: "fil", name: "Filipino", nativeName: "Filipino", flag: "🇵🇭", rtl: false },
  { code: "fr-CA", name: "French (Canada)", nativeName: "Français", flag: "🇨🇦", rtl: false },
  { code: "fr-FR", name: "French (France)", nativeName: "Français", flag: "🇫🇷", rtl: false },
  { code: "gl-ES", name: "Galician", nativeName: "Galego", flag: "🇪🇸", rtl: false },
  { code: "gu", name: "Gujarati", nativeName: "ગુજરાતી", flag: "🇮🇳", rtl: false },
  { code: "hi-IN", name: "Hindi", nativeName: "हिंदी", flag: "🇮🇳", rtl: false },
  { code: "hr", name: "Croatian", nativeName: "Hrvatski", flag: "🇭🇷", rtl: false },
  { code: "hu-HU", name: "Hungarian", nativeName: "Magyar", flag: "🇭🇺", rtl: false },
  { code: "hy-AM", name: "Armenian", nativeName: "Հայերեն", flag: "🇦🇲", rtl: false },
  { code: "id", name: "Indonesian", nativeName: "Bahasa Indonesia", flag: "🇮🇩", rtl: false },
  { code: "is-IS", name: "Icelandic", nativeName: "Íslenska", flag: "🇮🇸", rtl: false },
  { code: "it-IT", name: "Italian", nativeName: "Italiano", flag: "🇮🇹", rtl: false },
  { code: "iw-IL", name: "Hebrew", nativeName: "עברית", flag: "🇮🇱", rtl: true },
  { code: "ja-JP", name: "Japanese", nativeName: "日本語", flag: "🇯🇵", rtl: false },
  { code: "ka-GE", name: "Georgian", nativeName: "ქართული", flag: "🇬🇪", rtl: false },
  { code: "kk", name: "Kazakh", nativeName: "Қазақ", flag: "🇰🇿", rtl: false },
  { code: "km-KH", name: "Khmer", nativeName: "ខ្មែរ", flag: "🇰🇭", rtl: false },
  { code: "kn-IN", name: "Kannada", nativeName: "ಕನ್ನಡ", flag: "🇮🇳", rtl: false },
  { code: "ko-KR", name: "Korean", nativeName: "한국어", flag: "🇰🇷", rtl: false },
  { code: "ky-KG", name: "Kyrgyz", nativeName: "Кыргызча", flag: "🇰🇬", rtl: false },
  { code: "lo-LA", name: "Lao", nativeName: "ລາວ", flag: "🇱🇦", rtl: false },
  { code: "lt", name: "Lithuanian", nativeName: "Lietuvių", flag: "🇱🇹", rtl: false },
  { code: "lv", name: "Latvian", nativeName: "Latviešu", flag: "🇱🇻", rtl: false },
  { code: "mk-MK", name: "Macedonian", nativeName: "Македонски", flag: "🇲🇰", rtl: false },
  { code: "ml-IN", name: "Malayalam", nativeName: "മലയാളം", flag: "🇮🇳", rtl: false },
  { code: "mn-MN", name: "Mongolian", nativeName: "Монгол", flag: "🇲🇳", rtl: false },
  { code: "mr-IN", name: "Marathi", nativeName: "मराठी", flag: "🇮🇳", rtl: false },
  { code: "ms", name: "Malay", nativeName: "Bahasa Melayu", flag: "🇲🇾", rtl: false },
  { code: "ms-MY", name: "Malay (Malaysia)", nativeName: "Bahasa Melayu", flag: "🇲🇾", rtl: false },
  { code: "my-MM", name: "Burmese", nativeName: "မြန်မာ", flag: "🇲🇲", rtl: false },
  { code: "ne-NP", name: "Nepali", nativeName: "नेपाली", flag: "🇳🇵", rtl: false },
  { code: "nl-NL", name: "Dutch", nativeName: "Nederlands", flag: "🇳🇱", rtl: false },
  { code: "no-NO", name: "Norwegian", nativeName: "Norsk", flag: "🇳🇴", rtl: false },
  { code: "pa", name: "Punjabi", nativeName: "ਪੰਜਾਬੀ", flag: "🇮🇳", rtl: false },
  { code: "pl-PL", name: "Polish", nativeName: "Polski", flag: "🇵🇱", rtl: false },
  { code: "pt-BR", name: "Portuguese (Brazil)", nativeName: "Português", flag: "🇧🇷", rtl: false },
  { code: "pt-PT", name: "Portuguese (Portugal)", nativeName: "Português", flag: "🇵🇹", rtl: false },
  { code: "ro", name: "Romanian", nativeName: "Română", flag: "🇷🇴", rtl: false },
  { code: "ru-RU", name: "Russian", nativeName: "Русский", flag: "🇷🇺", rtl: false },
  { code: "si-LK", name: "Sinhala", nativeName: "සිංහල", flag: "🇱🇰", rtl: false },
  { code: "sk", name: "Slovak", nativeName: "Slovenčina", flag: "🇸🇰", rtl: false },
  { code: "sl", name: "Slovenian", nativeName: "Slovenščina", flag: "🇸🇮", rtl: false },
  { code: "sq", name: "Albanian", nativeName: "Shqip", flag: "🇦🇱", rtl: false },
  { code: "sr", name: "Serbian", nativeName: "Српски", flag: "🇷🇸", rtl: false },
  { code: "sv-SE", name: "Swedish", nativeName: "Svenska", flag: "🇸🇪", rtl: false },
  { code: "sw", name: "Swahili", nativeName: "Kiswahili", flag: "🇰🇪", rtl: false },
  { code: "ta-IN", name: "Tamil", nativeName: "தமிழ்", flag: "🇮🇳", rtl: false },
  { code: "te-IN", name: "Telugu", nativeName: "తెలుగు", flag: "🇮🇳", rtl: false },
  { code: "th", name: "Thai", nativeName: "ไทย", flag: "🇹🇭", rtl: false },
  { code: "tr-TR", name: "Turkish", nativeName: "Türkçe", flag: "🇹🇷", rtl: false },
  { code: "uk", name: "Ukrainian", nativeName: "Українська", flag: "🇺🇦", rtl: false },
  { code: "ur", name: "Urdu", nativeName: "اردو", flag: "🇵🇰", rtl: true },
  { code: "vi", name: "Vietnamese", nativeName: "Tiếng Việt", flag: "🇻🇳", rtl: false },
  { code: "zh-CN", name: "Chinese (Simplified)", nativeName: "简体中文", flag: "🇨🇳", rtl: false },
  { code: "zh-HK", name: "Chinese (Hong Kong)", nativeName: "繁體中文", flag: "🇭🇰", rtl: false },
  { code: "zh-TW", name: "Chinese (Traditional)", nativeName: "繁體中文", flag: "🇹🇼", rtl: false },
  { code: "zu", name: "Zulu", nativeName: "isiZulu", flag: "🇿🇦", rtl: false },
] as const;
